export const MAX_FREE_GENERATIONS = 4
